import { JsonConvert, JsonConverter, JsonCustomConvert, JsonObject, JsonProperty } from "json2typescript";
import { BaseResponse } from "../base-response";
import { Component, ComponentArrayConverter } from "./component";

@JsonObject("IPDGainLoss")
export class IPDGainLoss {
    @JsonProperty("freq_24", Number, true)
    freq_24: number = 0;
    @JsonProperty("freq_5", Number, true)
    freq_5: number = 0;
    @JsonProperty("freq_6", Number, true)
    freq_6: number = 0;
}

@JsonConverter
export class IPDGainLossConverter implements JsonCustomConvert<IPDGainLoss> {
  serialize() { }
  deserialize(data: any): IPDGainLoss {
    const gainLoss = new IPDGainLoss();
    gainLoss.freq_24 = Number(data?.freq_24 ?? 0);
    gainLoss.freq_5 = Number(data?.freq_5 ?? 0);
    gainLoss.freq_6 = Number(data?.freq_6 ?? 0);
    return gainLoss;
  }
}

@JsonConverter
export class IPDConverter implements JsonCustomConvert<IPD> {
  serialize() { }
  deserialize(data: any): IPD {
    const ipd = new IPD();
    ipd.IPDId = Number(data?.IPDId ?? data?.ipdId ?? 0);
    ipd.name = data?.name ?? "";
    ipd.note = data?.note ?? "";
    ipd.gainLoss = new IPDGainLossConverter().deserialize(data?.gainLoss ?? {});
    ipd.components = new ComponentArrayConverter().deserialize(data?.components ?? []);
    return ipd;
  }
}

@JsonConverter
export class IPDArrayConverter implements JsonCustomConvert<Array<IPD>> {
    serialize() { }
    deserialize(data: any): Array<IPD> {
      const converter = new IPDConverter();
      return (data ?? []).map((item: any) => converter.deserialize(item));
    }
}

@JsonConverter
export class IPDListConverter implements JsonCustomConvert<IPDCountList> {
    serialize() { }
    deserialize(data: any): IPDCountList {
      const list = new IPDCountList();
      list.count = Number(data?.count ?? 0);
      list.items = new IPDArrayConverter().deserialize(data?.items ?? data?.data ?? []);
      return list;
    }
}

@JsonObject("IPD")
export class IPD {
    @JsonProperty("IPDId", Number, true)
    IPDId: number = 0;
    @JsonProperty("name", String, true)
    name: string = "";
    @JsonProperty("note", String, true)
    note: string = "";
    @JsonProperty("gainLoss", IPDGainLossConverter, true)
    gainLoss: IPDGainLoss = new IPDGainLoss();
    @JsonProperty("components", ComponentArrayConverter, true)
    components: Array<Component> = [];

}

@JsonObject("IPDCountList")
export class IPDCountList {
    @JsonProperty("count", Number, true)
    count: number = 0;
    items: Array<IPD> = [];
}

@JsonObject("IPDData")
export class IPDData extends BaseResponse {
    @JsonProperty("data", IPDConverter, true)
    data: IPD = new IPD();
}

@JsonObject("IPDDataArray")
export class IPDDataArray extends BaseResponse {
    @JsonProperty("data", IPDListConverter, true)
    data: IPDCountList = new IPDCountList();
} 
